import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-recuperar-clave',
  templateUrl: './recuperar-clave.component.html',
  styleUrls: ['./recuperar-clave.component.css']
})
export class RecuperarClaveComponent implements OnInit {

  formulario: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _auth: AuthService,
    private _utils: UtilsService
  ) { }

  ngOnInit(): void {
    this.formulario = this.fb.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSolicitarRecuperacion(): void {
    if (this.formulario.invalid) {
      this._utils.mensajeErrorVisto('Por favor, complete todos los campos correctamente.');
      return;
    }

    this.loading = true;
    const username = this.formulario.value.username;
    const email = this.formulario.value.email;

    // El backend valida usuario/email, verifica LDAP y envía el correo con el link de reseteo
    this._auth.solicitarRecuperacionClave(username, email).subscribe({
      next: () => {
        this.loading = false;
        this._utils.mensajeOKToast(
          'Se ha enviado un correo electrónico con las instrucciones para restablecer su contraseña.',
          4000
        );
        this.router.navigate(['/login']);
      },
      error: (error) => {
        this.loading = false;
        const mensaje = error.error?.mensaje || error.message || 'Error al procesar la solicitud.';
        this._utils.mensajeErrorVisto(mensaje);
      }
    });
  }

  volverAlLogin(): void {
    this.router.navigate(['/login']);
  }
}
